const checkNewRelicIsEnabled = () => {
  return typeof window?.newrelic?.setCustomAttribute === 'function';
};

export const noticeError = (
  message: string,
  options?: { [key: string]: string }
) => {
  if (checkNewRelicIsEnabled()) {
    window.newrelic?.noticeError(message, options);
  }
};
